module.exports = __webpack_public_path__ + "static/intro_info_mobile-bd0ba816143de96649300cde1cd64d36.png";